import { AppShell, Group } from "@mantine/core"
import { ReactNode } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"

import { Logo } from "../../icons/logo/Logo.tsx"
import { LogoDark } from "../../icons/logo/LogoDark.tsx"

import classes from "./AppHeader.module.css"

type HeaderNavItem = {
  label: string
  link: string
}
type Props = {
  children?: ReactNode
  theme?: "supplier" | "brand"
  justify?: "space-between" | "center" | "left" | "right"
  navItems?: HeaderNavItem[]
}
export const AppHeader = ({
  children,
  theme = "brand",
  justify = "space-between",
  navItems,
  ...props
}: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <AppShell.Header py="sm" px="md" className={classes[theme]} {...props}>
      <Group justify={justify} wrap="nowrap" w="100%">
        {theme === "brand" ? (
          <Link to="/">
            <Logo height={32} />
          </Link>
        ) : theme === "supplier" ? (
          <LogoDark height={32} className={classes["header-logo"]} />
        ) : null}
        {navItems ? (
          <Group
            wrap="nowrap"
            justify="right"
            gap="var(----tfg-molecule-padding-x)"
          >
            {navItems?.map((navItem, index) => (
              <a
                key={`${navItem.label}-${index}`}
                href={navItem.link}
                className={classes.link}
                data-active={location.pathname === navItem.link || undefined}
                onClick={(event) => {
                  event.preventDefault()
                  navigate(navItem.link)
                }}
              >
                {navItem.label}
              </a>
            ))}
          </Group>
        ) : null}
        <Group wrap="nowrap">{children}</Group>
      </Group>
    </AppShell.Header>
  )
}
